import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { withLatestFrom, tap, filter, switchMap, map, catchError, of } from 'rxjs';
import { FittingsService } from '../../services/fittings.service';
import { SearchService } from '../../services/search.service';

import * as fromActions from '../actions/search.actions';
import * as fromReducer from '../reducers/search.reducer';
import * as fromSelectors from '../selectors/search.selectors'

import * as fromStore from '../../store';

@Injectable()
export class SearchEffects {
  constructor(
    private actions$: Actions,
    private store: Store<fromReducer.State>,
    private searchService: SearchService,
    private fittingsService: FittingsService
  ) { }


  loadSearchResults$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.setSearchQuery),
    withLatestFrom(this.store.select(fromSelectors.selectQ)),
    switchMap(([action, q]) => this.searchService.getSearchResults(q || '-foo')
      .pipe(map(results => fromActions.loadSearchResultsSuccess({ results })),
        catchError(error => of(fromActions.loadSearchResultsFailure({ error })))))));


  loadDwgGraph$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.activateSearchItem),
    filter(action => !!action.item.partNumber),
    switchMap(action => this.fittingsService.getFlatterFilesDrawingDictionary(action.item.partNumber || 'foo')
      .pipe(map(dictionary => fromStore.actions.FITTINGS.loadActiveFittingDrawingDictionarySuccess({ dictionary })),
        catchError(error => of(fromStore.actions.FITTINGS.loadActiveFittingConfigurationsFail({ error })))))));
}
